import styled from '@emotion/styled';
import {colors, fontSize, sizes} from 'patient-ping-remedy/packages/theme';
import Input from 'patient-ping-remedy/packages/input';
import {Menu} from 'patient-ping-remedy/packages/menu';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: ${sizes.small};
  width: 34rem;
`;

export const Search = styled(Input)`
  padding: ${sizes.small};

  input {
    font-family: inherit;
    font-size: ${fontSize.small};
    border-radius: ${sizes.xxSmall};
    margin: 0;

    & + span {
      display: none;
    }
  }
`;

export const ScrollableMenu = styled(Menu)`
  max-height: 23rem;
  overflow-y: auto;
`;

export const AssignedSection = styled.div`
  border-top: 1px solid ${colors.gray2};
  padding: ${sizes.small} ${sizes.xSmall} 0 ${sizes.small};
  margin-top: ${sizes.small};
`;
